module.exports = __webpack_public_path__ + "static/seo-services-a8c279f9d291716cab758029f37b9496.png";